import { render } from "./exam-image-edit.vue?vue&type=template&id=176e4eba&scoped=true"
import script from "./exam-image-edit.vue?vue&type=script&lang=js"
export * from "./exam-image-edit.vue?vue&type=script&lang=js"

import "./exam-image-edit.vue?vue&type=style&index=0&id=176e4eba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176e4eba"]])

export default __exports__